import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated) {
      // Check if this was a manual logout
      const manualLogout = sessionStorage.getItem('manual_logout');
      if (!manualLogout) {
        auth.signinRedirect(); // Automatically redirect to SSO
      } else {
        // Clear the flag after checking
        sessionStorage.removeItem('manual_logout');
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.signinRedirect]);

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Authentication error: {auth.error.message}</div>;
  }

  return auth.isAuthenticated ? <>{children}</> : null;
};
